module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_dress_try-ceee2343d199da621f9a856bead32da8.jpg";